export function phoneFormatter(value: string): string {
  if (!value) return value;
  if (value.length > 11) return value;

  const regexp = value.length > 10 ? /^(.{0,2})(.{0,5})(\d{0,4}).*/ : /^(.{0,2})(.{0,4})(.{0,4}).*/;

  return value.replace(regexp, '($1) $2-$3');
}
